import { clsx } from 'clsx';
import { useEffect, useState } from 'react';
import { CheckboxGroupInput } from 'ra-ui-materialui';
import { makeStyles } from '@mui/styles';

import { http } from '@network';

interface Props {
  source: string;
  label?: string;
  hideLabel?: boolean;
  reference?: string;
  optionKey?: string;
  optionLabel?: string;
  columns?: number;
  className?: string;
}

export const ManyCheckboxInput = ({
  source, label, reference, optionKey, optionLabel, columns, className,
}: Props) => {
  const cls = useStyles();
  const [options, setOptions] = useState<CheckOption[]>([]);

  useEffect(() => {
    (async () => {
      const response = await http.get<any>(reference || source, {
        params: { _start: 0, _end: 9999999 },
      });
      const nextOptions: CheckOption[] = [];
      if (response.data && Array.isArray(response.data)) {
        (response.data ?? []).forEach((model: any) => {
          nextOptions.push({
            id: model[optionKey ?? 'id'],
            name: model[optionLabel ?? 'nameMx'] || model['name'] || model['title'],
          });
        });
      }
      setOptions(nextOptions);
    })();
  }, []);

  const inputLabel = label || source.slice(0, 1).toUpperCase().concat(source.slice(1));

  return (
    <CheckboxGroupInput
      name={source}
      source={source}
      label={inputLabel}
      choices={options}
      className={clsx(
        className,
        columns === 4 && cls.columns4,
        columns === 3 && cls.columns3,
        columns === 2 && cls.columns2,
      )}
    />
  );
};

const useStyles = makeStyles({
  columns4: {
    '& .MuiFormControlLabel-root': {
      width: '24%',
    },
  },
  columns3: {
    '& .MuiFormControlLabel-root': {
      width: '33%',
    },
  },
  columns2: {
    '& .MuiFormControlLabel-root': {
      width: '49%',
    },
  },
});

interface CheckOption {
  id: string,
  name: string,
}
